enum GtmFormularfeldId {
    vnTitel = 'vnTitel',
    vnAnrede = 'vnAnrede',
    vnAnschriftHsnr = 'vnAnschriftHsnr',
    vnAnschriftOrt = 'vnAnschriftOrt',
    vnAnschriftStrasse = 'vnAnschriftStrasse',
    vnAnschriftPlz = 'vnAnschriftPlz',
    vnKommEmailPrivat = 'vnKommEmailPrivat',
    vnKommHandyPrivat = 'vnKommHandyPrivat',
    vnName = 'vnName',
    vnVorname = 'vnVorname',
    vnGeburtsdatum = 'vnGeburtsdatum',
    vnBankIban = 'vnBankIban',
    hundeAnzahl = 'hundeAnzahl',
    hundeName = 'hundeName',
    hundeRasse = 'hundeRasse',
    vorschaden = 'vorschaden',
    vorschadenFreitext = 'vorschadenFreitext',
    optInMail = 'optInMail',
    optInSms = 'optInSms',
    optInTelefon = 'optInTelefon',
    rasseVersicherbar = 'rasseVersicherbar',
    produktVsBeginn = 'produktVsBeginn',
    produktSb = 'produktSb',
    produktVs = 'produktVs',
    produktZahlungsweise = 'produktZahlungsweise'
}

export const createGtmFieldId = (idGtm: GtmFormularfeldId, idGtmIndex?: number) => {
    const idGtmStr: string = GtmFormularfeldId[idGtm];
    return idGtmIndex ? (`${idGtmStr}-${idGtmIndex}`) : idGtmStr;
};

export default GtmFormularfeldId;